import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDownOnSquareIcon, ArrowDownTrayIcon, ArrowUturnLeftIcon, ArrowUturnRightIcon, DocumentDuplicateIcon, EnvelopeIcon, EnvelopeOpenIcon, EyeIcon, FolderOpenIcon, LinkIcon, PaperClipIcon, PencilIcon, PlusIcon, PrinterIcon, ShareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ChatEventActionEnum, DriveEventActionEnum, GmailAnalyticsEnum, GmailEventActionEnum } from '@workalizer/shared';
var EventIcon = function (_a) {
    var action = _a.action;
    switch (action) {
        case GmailAnalyticsEnum.GMAIL_EMAIL_SENT:
        case GmailEventActionEnum.GMAIL_MESSAGE_SENT:
            return _jsx(EnvelopeIcon, {});
        case GmailAnalyticsEnum.GMAIL_EMAIL_RECEIVED:
        case GmailEventActionEnum.GMAIL_MESSAGE_RECEIVED:
            return _jsx(EnvelopeOpenIcon, {});
        case GmailEventActionEnum.GMAIL_MESSAGE_OPENED:
        case GmailEventActionEnum.GMAIL_MESSAGE_VIEWED:
            return _jsx(EyeIcon, {});
        case GmailEventActionEnum.GMAIL_MESSAGE_REPLIED:
            return _jsx(ArrowUturnLeftIcon, {});
        case GmailEventActionEnum.GMAIL_MESSAGE_FORWARDED:
            return _jsx(ArrowUturnRightIcon, {});
        case GmailEventActionEnum.GMAIL_LINK_CLICKED:
        case GmailEventActionEnum.GMAIL_ATTACHMENT_LINK_CLICKED:
            return _jsx(LinkIcon, {});
        case GmailEventActionEnum.GMAIL_ATTACHMENT_DOWNLOADED:
        case GmailEventActionEnum.GMAIL_MESSAGE_DOWNLOADED:
            return _jsx(ArrowDownTrayIcon, {});
        case GmailEventActionEnum.GMAIL_ATTACHMENT_SAVED_TO_DRIVE:
            return _jsx(FolderOpenIcon, {});
        case GmailEventActionEnum.GMAIL_ATTACHMENT_PREVIEWED:
            return _jsx(PaperClipIcon, {});
        case GmailEventActionEnum.GMAIL_SPAM_CLASSIFICATION_APPLIED:
            return _jsx(TrashIcon, {});
        case DriveEventActionEnum.DOCUMENT_VIEW:
            return _jsx(EyeIcon, {});
        case DriveEventActionEnum.DOCUMENT_EDIT:
            return _jsx(PencilIcon, {});
        case DriveEventActionEnum.DOCUMENT_CREATE:
            return _jsx(PlusIcon, {});
        case DriveEventActionEnum.DOCUMENT_DELETE:
            return _jsx(TrashIcon, {});
        case DriveEventActionEnum.DOCUMENT_COPY:
            return _jsx(DocumentDuplicateIcon, {});
        case DriveEventActionEnum.DOCUMENT_ADD_TO_FOLDER:
            return _jsx(FolderOpenIcon, {});
        case DriveEventActionEnum.DOCUMENT_REMOVE_FROM_FOLDER:
            return _jsx(FolderOpenIcon, {});
        case DriveEventActionEnum.DOCUMENT_DOWNLOAD:
            return _jsx(ArrowDownOnSquareIcon, {});
        case DriveEventActionEnum.DOCUMENT_SHARE:
            return _jsx(ShareIcon, {});
        case DriveEventActionEnum.DOCUMENT_PRINT:
            return _jsx(PrinterIcon, {});
        case DriveEventActionEnum.DOCUMENT_TRASH:
            return _jsx(TrashIcon, {});
        case DriveEventActionEnum.DOCUMENT_RESTORE:
            return _jsx(ArrowDownOnSquareIcon, {});
        case ChatEventActionEnum.CHAT_MESSAGE_POSTED:
        case ChatEventActionEnum.CHAT_MESSAGE_EDITED:
        case ChatEventActionEnum.CHAT_REACTION_ADDED:
            return _jsx(PencilIcon, {});
        default:
            return _jsx(EyeIcon, {});
    }
};
export default EventIcon;
